export default __webpack_public_path__ + "static/media/arcteryx.0b963a0f.png";